// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"158":"91025ab7","181":"d5c9b39e","284":"2e597345","373":"d17f4a89","524":"bbca98ce","596":"b2830253"}[chunkId] + ".chunk.js";
};